import axios from 'axios';
import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

const NewUserModal = ({ handleClose, setResult }) => {



    const refSubmitDis = useRef();
    const [errorMessage, setErrorMessage] = useState({});


    const handleSubmitData = async (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        const submitButton = refSubmitDis.current;

        if (submitButton) {
            submitButton.disabled = true;
        }

        setErrorMessage({});

        try {
            const formData = new FormData(form);

            const response = await axios.post(
                "https://api.velormall.com/api/admin/user/view/create",
                Object.fromEntries(formData.entries()),
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = response?.data;

            if (data?.success) {
                setResult(data?.data);
                handleClose();
                form.reset();
                toast.success(data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored",
                });
            } else {
                toast.error(data?.message, {
                    position: "top-right",
                    autoClose: 5000,
                    theme: "colored",
                });
            }
        } catch (error) {
            const responseData = error?.response?.data;
            setErrorMessage(responseData?.errors || {});

            toast.error(
                responseData?.message,
                {
                    position: "top-right",
                    autoClose: 5000,
                    theme: "colored",
                }
            );
        } finally {
            if (submitButton) {
                submitButton.disabled = false;
            }
        }
    };



    return (
        <>
            <Modal.Body>
                <form onSubmit={handleSubmitData}>
                    <div class="modal-body">
                        <div class="form-group">
                            <label htmlFor="name" class="required">
                                Username
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                name="username"
                                id="name"
                            />
                            {errorMessage?.username && (
                                <span className="text-danger pt-2">
                                    {errorMessage?.username?.msg}
                                </span>
                            )}
                        </div>
                        <div class="form-group">
                            <label htmlFor="name" class="required">
                                Email
                            </label>
                            <input
                                type="email"
                                class="form-control"
                                name="email"
                                id="name"
                            />
                            {errorMessage?.email && (
                                <span className="text-danger pt-2">
                                    {errorMessage?.email?.msg}
                                </span>
                            )}
                        </div>
                        <div class="form-group">
                            <label htmlFor="name" class="required">
                                Password
                            </label>
                            <input
                                type="password"
                                class="form-control"
                                name="password"
                                id="name"
                            />
                            {errorMessage?.password && (
                                <span className="text-danger pt-2">
                                    {errorMessage?.password?.msg}
                                </span>
                            )}
                        </div>

                        <button
                            type="submit"
                            ref={refSubmitDis}
                            class="btn btn-primary w-100 h-45"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </>
    );
};

export default NewUserModal;